import { useMutation } from '@tanstack/react-query'
import { contactDetailApi } from '../lib/api'
import type { ContactMatchRequest, ContactMatchCandidate } from '../types/contactDetail'

// Voter-file candidate lookup for the contact-create flow (Task 5's POST /api/contacts/match).
// Read-style mutation (search-as-you-type against a request body, not a GET-cacheable query) --
// it doesn't mutate server state, so there's nothing to invalidate on success.
export function useMatchContact() {
  return useMutation({
    mutationFn: async (data: ContactMatchRequest): Promise<ContactMatchCandidate[]> =>
      (await contactDetailApi.matchContact(data)).data,
  })
}
